var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 7H4",
    stroke: "#1E1D1C",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 13C9 13 7.38071 10.7549 6 9.57143C4.61929 8.38796 2 7 2 7C2 7 4.61929 5.61204 6 4.42857C7.38071 3.2451 9 1 9 1",
    stroke: "#1E1D1C",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.1ab43a38979dbd067039d78bf6b75055.svg";
export { ForwardRef as ReactComponent };